import { FaApple, FaWindows } from "react-icons/fa";
import { MdOutlineDesktopWindows } from "react-icons/md";
import iamrecipe from "../assets/images/Drupal/iamrecipe.png";
import oauthclient from "../assets/images/Drupal/oauthclient.png";
import samlsp from "../assets/images/Drupal/samlsp.png";
import ssorecipe from "../assets/images/Drupal/ssorecipe.png";
import userprovisioning from "../assets/images/Drupal/userprovisioning.png";
import sessionmanagement from "../assets/images/Drupal/sessionmanagement.png";



const drupalData = [
    {
      text: "IAM Recipe - Multimodules",
      icon: <img src={iamrecipe} style={{width:'15px'}}/>,
      videoId: "V8-jLF2E3I4",
      videoType: "youtube"
    },
    {
      text: "miniOrange SSO Recipe",
      icon: <img src={ssorecipe} style={{width:'15px'}}/>,
      videoId: "p9qDG56uoF4",
      videoType: "youtube"
    },
    {
      text: "User Provisioning",
      icon: <img src={userprovisioning} style={{width:'15px'}}/>,
      videoId: "EjnYnkWw168",
      videoType: "youtube"
    },
    {
      text: "SAML SP- full featured",
      icon:<img src={samlsp} style={{width:'15px'}}/>,
      videoId: "iqDYvW43jio",
      videoType: "youtube"
    },
    {
      text: "OAuth Client- full featured",
      icon: <img src={oauthclient} style={{width:'18px'}}/>,
      videoId: "YnDV_RG-2II",
      videoType: "youtube"
    },
    {
      text: "User Session Management",
      icon: <img src={sessionmanagement} style={{width:'18px'}}/>,
      videoId: "VWpId55aVrY",
      videoType: "youtube"
    },
  ];


export default drupalData;